<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="package-locked-dialog"
    width="400px"
    append-to-body
  >
    <section class="package-locked-dialog__content">
      <button class="package-locked-dialog__close" type="button" :aria-label="$t('common.Close')" @click="closeDialog">
        <i class="el-icon-close"></i>
      </button>
      <img
        class="package-locked-dialog__illustration"
        src="@/assets/images/marketingTools/package-expire.png"
        alt=""
      />
      <h2>{{ $t('dashboard.Package-Locked-Dialog-Title') }}</h2>
      <p class="package-locked-dialog__description">{{ $t('dashboard.Package-Locked-Dialog-Content') }}</p>
      <div class="package-locked-dialog__actions">
        <button
          type="button"
          class="package-locked-dialog__button package-locked-dialog__button--primary"
          @click="closeDialog()">
          {{ $t('dashboard.Package-Locked-Dialog-Confirm') }}
        </button>
      </div>
    </section>
  </el-dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {eventBus} from "@/main";
import EventCenter from "@/utils/EventCenter";


const visible = ref(false);

const openDialog = () => {
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
};


onMounted(() => {
  eventBus.$on(EventCenter.openPackageLockedDialog, openDialog);
});

onBeforeUnmount(() => {
  eventBus.$off(EventCenter.openPackageLockedDialog, openDialog);
});
</script>

<style lang="scss">
// Element 的 dialog 会挂载到 body，使用非 scoped 样式并覆盖默认顶部 margin，使弹窗保持视口居中。
.package-locked-dialog {
  top: 50%;
  margin: 0 auto !important;
  transform: translateY(-50%);
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, rgb(255 0 0 / 4%) 0%, rgb(255 0 0 / 0%) 29.742%), var(--mc-background-main-color);
  
  .el-dialog__header {
    display: none;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  &__content {
    position: relative;
    box-sizing: border-box;
    min-height: 354px;
    padding: 40px;
    text-align: center;
  }
  
  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    display: grid;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    place-items: center;
    color: #a4acb9;
    background: transparent;
    cursor: pointer;
    
    .el-icon-close {
      font-size: 16px;
    }
  }
  
  &__illustration {
    display: block;
    width: 120px;
    height: 120px;
    margin: 0 auto 8px;
    object-fit: contain;
  }
  
  h2 {
    margin: 0;
    color: #17181a;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }
  
  &__description {
    width: 320px;
    margin: 16px auto 24px;
    color: var(--mc-info-text-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  
  &__actions {
    display: grid;
    gap: 8px;
  }
  
  &__button {
    width: 100%;
    min-height: 36px;
    border: 0;
    border-radius: var(--mc-border-radius-normal);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    
    &--primary {
      color: var(--mc-background-main-color);
      background: var(--mc-color-primary);
    }
  }
}
</style>
